import Box from '@mui/material/Box';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';

import { Typography } from '../Typography/Typography';

interface Linear extends Omit<LinearProgressProps, 'variant'> {
  variant?: 'line';
}

interface Circular extends Omit<CircularProgressProps, 'variant'> {
  variant?: 'circle';
  title?: string;
}

type Props = Linear | Circular;

export const CenteredLoader = ({ variant = 'circle', title, ...rest }: Props) => (
  <Box
    sx={{
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',
      gap: 1,
      height: '100%',
      justifyContent: 'center',
    }}
  >
    {variant === 'circle' ? <CircularProgress {...rest} /> : <LinearProgress {...rest} />}
    {title ? (
      <Typography variant="body2" color="secondary">
        {title}
      </Typography>
    ) : null}
  </Box>
);
